import Immutable from 'seamless-immutable';

import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getCategoriesRequest: [],
  getCategoriesSuccess: ['data'],
  getCategoriesError: ['error'],

  getBrandsRequest: ['data'],
  getBrandsSuccess: ['data'],
  getBrandsError: ['error'],

  findTextRequest: ['text'],
  findTextSuccess: [],
  findTextError: ['error'],
});

const INITIAL_STATE = Immutable({
  error: {},
  isLoading: false,
  categories: [],
  fullCategories: [],
  brands: [],
  fullBrands: [],
  pagination: {
    limit: 10,
    offset: 0,
    pageNumber: 1,
    filter: null,
  },
});

const getCategoriesSuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data });
const getCategoriesError = (state = INITIAL_STATE, { error }) => state.merge({ error });

const getBrandsSuccess = (state = INITIAL_STATE, { data }) => state.merge({ ...data });
const getBrandsError = (state = INITIAL_STATE, { error }) => state.merge({ error });

const findTextRequest = (state = INITIAL_STATE) => state.set('isLoading', true);
const findTextSuccess = (state = INITIAL_STATE) => state.set('isLoading', false);
const findTextError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

export default createReducer(INITIAL_STATE, {
  [Types.GET_CATEGORIES_SUCCESS]: getCategoriesSuccess,
  [Types.GET_CATEGORIES_ERROR]: getCategoriesError,

  [Types.GET_BRANDS_SUCCESS]: getBrandsSuccess,
  [Types.GET_BRANDS_ERROR]: getBrandsError,

  [Types.FIND_TEXT_REQUEST]: findTextRequest,
  [Types.FIND_TEXT_SUCCESS]: findTextSuccess,
  [Types.FIND_TEXT_ERROR]: findTextError,
});
